import Base from '../Base';

export default class SettingSimulator extends Base {
    static url = '/api/setting/simulator';
}
